export default __webpack_public_path__ + "static/airbnb-3-fffba5a07b9eebe0020357119edd3ed4.png";